(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romatoki-brand-film"] && !Shopify.designMode) return;
  try {
    
  /**
   * ROMATOKI brand film player.
   *
   * Deliberately hand-rolled rather than using the browser's native controls:
   * the native control bar is a chrome-coloured slab that fights a full-bleed
   * cinematic band, and this only needs three affordances (play/pause, sound,
   * fullscreen) plus a progress hairline.
   *
   * NO LIQUID IN THIS BLOCK. A section's javascript block is not rendered by
   * Liquid — a tag here would ship verbatim and break the whole concatenated
   * section bundle. Everything configurable arrives on data- attributes.
   */
  (function () {
    var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(section) {
      if (section.dataset.rtFilmReady === 'on') return;
      section.dataset.rtFilmReady = 'on';

      var video = section.querySelector('[data-rt-film-video]');
      var frame = section.querySelector('[data-rt-film-frame]');
      var toggle = section.querySelector('[data-rt-film-toggle]');
      var soundBtn = section.querySelector('[data-rt-film-sound]');
      var soundLabel = section.querySelector('[data-rt-film-sound-label]');
      var fsBtn = section.querySelector('[data-rt-film-fullscreen]');
      var progress = section.querySelector('[data-rt-film-progress]');
      if (!video) return;

      var wantsAutoplay = section.dataset.autoplay === 'true' && !REDUCED;
      var labelOn = section.dataset.labelSoundOn || 'Sound on';
      var labelOff = section.dataset.labelSoundOff || 'Sound off';
      var userPaused = false;

      function setState(state) {
        section.setAttribute('data-state', state);
      }
      setState('paused');

      function syncSoundLabel() {
        // The button offers the action, not the status: while muted it says
        // "Sound on" because that is what pressing it does.
        if (soundLabel) soundLabel.textContent = video.muted ? labelOn : labelOff;
        if (soundBtn) soundBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      }
      syncSoundLabel();

      // Attach the <source> elements the markup deliberately withholds. See the
      // PLAYBACK BEHAVIOUR note at the top of this file: server-rendered
      // sources cost 13.4MB on every page load, whether or not anyone scrolls
      // this far. Appending to a NETWORK_EMPTY element starts resource
      // selection by itself, so load() is only needed if something already
      // touched the element — calling it unconditionally would abort the
      // play() that follows.
      var mounted = false;
      function mountSources() {
        if (mounted) return;
        mounted = true;
        var urls = [
          [video.getAttribute('data-src-hls'), 'application/x-mpegURL'],
          [video.getAttribute('data-src-mp4'), 'video/mp4']
        ];
        var frag = document.createDocumentFragment();
        var attached = 0;
        for (var i = 0; i < urls.length; i++) {
          if (!urls[i][0]) continue;
          var el = document.createElement('source');
          el.src = urls[i][0];
          el.type = urls[i][1];
          frag.appendChild(el);
          attached++;
        }
        if (!attached) return;
        var wasEmpty = video.networkState === 0; // NETWORK_EMPTY
        video.appendChild(frag);
        if (!wasEmpty) video.load();
      }

      function attemptPlay() {
        mountSources();
        var p = video.play();
        // Older browsers return undefined from play(); only a real promise can
        // reject, and a rejection here is normal (iOS Low Power Mode, data
        // saver), not an error worth logging.
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            setState('paused');
          });
        }
      }

      video.addEventListener('play', function () { setState('playing'); });
      video.addEventListener('pause', function () { setState('paused'); });

      video.addEventListener('timeupdate', function () {
        if (!progress || !video.duration) return;
        progress.style.width = ((video.currentTime / video.duration) * 100) + '%';
      });

      // Without loop, hold the last frame and offer a replay rather than
      // snapping back to the poster.
      video.addEventListener('ended', function () {
        setState('paused');
        if (progress) progress.style.width = '100%';
      });

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (video.paused) {
            userPaused = false;
            attemptPlay();
          } else {
            userPaused = true;
            video.pause();
          }
        });
      }

      if (soundBtn) {
        soundBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          syncSoundLabel();
          // Unmuting is a user gesture, so this is the one moment a paused
          // film is allowed to start itself with audio.
          if (!video.muted && video.paused) {
            userPaused = false;
            attemptPlay();
          }
        });
      }

      if (fsBtn) {
        fsBtn.addEventListener('click', function () {
          var target = frame || video;
          if (document.fullscreenElement) {
            document.exitFullscreen();
          } else if (target.requestFullscreen) {
            target.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            // iPhone Safari never fullscreens an arbitrary element — only the
            // video element itself, through this proprietary call.
            video.webkitEnterFullscreen();
          }
        });
      }

      // Only fetch and play once the band is actually on screen, and give the
      // bytes back nothing when it is not. Works regardless of which element
      // is the scroll container, which matters here: Horizon scrolls
      // .page-wrapper, not the document.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                mountSources();
                if (wantsAutoplay && video.paused && !userPaused) attemptPlay();
              } else if (!video.paused) {
                video.pause();
              }
            });
          },
          { threshold: 0.35 }
        );
        io.observe(section);
      } else if (wantsAutoplay) {
        attemptPlay();
      }
    }

    function boot() {
      var sections = document.querySelectorAll('[data-rt-film]');
      for (var i = 0; i < sections.length; i++) init(sections[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romatoki-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__rtCompare) return;
      root.__rtCompare = true;
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-vs-btn]'));
      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function select(chip, animate) {
        var n = chip.getAttribute('data-vs-btn');
        var changed = root.getAttribute('data-vs') !== n;
        root.setAttribute('data-vs', n);
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', on ? 'true' : 'false');
          c.tabIndex = on ? 0 : -1;
        });
        root.querySelectorAll('[data-col]').forEach(function (cell) {
          if (cell.getAnimations) cell.getAnimations().forEach(function (a) { a.cancel(); });
        });
        if (changed && animate && !motion.matches) {
          root.querySelectorAll('[data-col="' + n + '"]').forEach(function (cell, i) {
            if (!cell.animate) return;
            cell.animate(
              [{ opacity: 0, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }],
              { duration: 260, delay: Math.min(i * 18, 90), fill: 'backwards', easing: 'cubic-bezier(.22,1,.36,1)' }
            );
          });
        }
      }
      chips.forEach(function (chip, i) {
        chip.addEventListener('click', function () { select(chip, true); });
        chip.addEventListener('keydown', function (e) {
          var index = i;
          if (e.key === 'ArrowRight') index = (i + 1) % chips.length;
          else if (e.key === 'ArrowLeft') index = (i + chips.length - 1) % chips.length;
          else if (e.key === 'Home') index = 0;
          else if (e.key === 'End') index = chips.length - 1;
          else return;
          e.preventDefault();
          chips[index].focus();
          select(chips[index], true);
        });
      });
      if (chips.length) select(chips[Number(root.getAttribute('data-vs') || 1) - 1] || chips[0], false);
    }
    Array.prototype.slice.call(document.querySelectorAll('[data-rt-compare]')).forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      Array.prototype.slice.call(e.target.querySelectorAll('[data-rt-compare]')).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romatoki-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function panelOf(el) {
      return el && el.closest ? el.closest('[data-faq-panel]') : null;
    }

    function select(root, n) {
      var value = String(n);
      root.setAttribute('data-faq', value);
      var chips = root.querySelectorAll('[data-faq-btn]');
      for (var i = 0; i < chips.length; i++) {
        var on = chips[i].getAttribute('data-faq-btn') === value;
        chips[i].classList.toggle('is-active', on);
        chips[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }

    /*
      The whole reason this file has JavaScript. An id can now live inside a
      hidden panel, so reveal its panel before anything else looks at it. A
      no-op when the panel is already showing, or when "All" is selected.
    */
    function revealId(id) {
      if (!id) return;
      var target;
      try {
        target = document.getElementById(id);
      } catch (e) {
        return;
      }
      var panel = panelOf(target);
      if (!panel) return;
      var root = panel.closest('[data-rt-faq]');
      if (!root) return;
      var n = panel.getAttribute('data-faq-panel');
      var current = root.getAttribute('data-faq');
      if (current === n || current === '0') return;
      select(root, n);
    }

    function idFromHash(hash) {
      if (!hash || hash.length < 2) return '';
      try {
        return decodeURIComponent(hash.slice(1));
      } catch (e) {
        return hash.slice(1);
      }
    }

    function init(root) {
      if (!root || root.__rtFaq) return;
      root.__rtFaq = true;

      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-faq-btn]'));
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          select(root, chip.getAttribute('data-faq-btn'));
        });
      });

      /*
        Backstop, path 3. "toggle" does not bubble, hence capture. If anything
        at all opens a <details> whose panel is hidden, show that panel.
      */
      root.addEventListener(
        'toggle',
        function (event) {
          var t = event.target;
          if (!t || t.tagName !== 'DETAILS' || !t.open) return;
          var panel = panelOf(t);
          if (!panel) return;
          var n = panel.getAttribute('data-faq-panel');
          var current = root.getAttribute('data-faq');
          if (current === n || current === '0') return;
          select(root, n);
        },
        true
      );

      // Path 1a: landed here with a fragment already in the URL.
      revealId(idFromHash(window.location.hash));
    }

    function initAll(scope) {
      Array.prototype.slice.call(scope.querySelectorAll('[data-rt-faq]')).forEach(init);
    }

    /*
      Path 2, and the delicate one. In-page anchors on this theme never reach
      hashchange: the header cancels them because the document is not the
      scroll container, then measures the target's rectangle synchronously —
      which reads 0x0 at 0,0 if the target is still inside a display:none
      panel, throwing the reader to the top of the page. Capture on WINDOW
      runs before any capture listener on DOCUMENT, which is where the
      header's listener lives, so the panel is open by the time it measures.
      Do not move this to document and do not let it bubble.
    */
    window.addEventListener(
      'click',
      function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }
        var el = event.target;
        var link = el && el.closest ? el.closest('a[href*="#"]') : null;
        if (!link) return;
        var href = link.getAttribute('href') || '';
        var hash =
          href.charAt(0) === '#'
            ? href
            : link.pathname === window.location.pathname
              ? link.hash
              : '';
        revealId(idFromHash(hash));
      },
      true
    );

    // Path 1b: back/forward, or a fragment typed into the address bar.
    window.addEventListener('hashchange', function () {
      revealId(idFromHash(window.location.hash));
    });

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romatoki-features"] && !Shopify.designMode) return;
  try {
    
  /**
   * Features carousel — paddles, dots, keyboard. Scroll-snap does the actual
   * moving; this only reads position and issues scrollTo/scrollBy.
   *
   * No Liquid in this block. Shopify does not render it here; a stray tag
   * ships verbatim and breaks the whole concatenated section bundle.
   */
  (function () {
    function init(root) {
      if (root.dataset.rtCarousel === 'on') return;
      root.dataset.rtCarousel = 'on';

      var viewport = root.querySelector('[data-rt-carousel-viewport]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-rt-carousel-item]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rt-carousel-dot]'));
      var prev = root.querySelector('[data-rt-carousel-prev]');
      var next = root.querySelector('[data-rt-carousel-next]');
      if (!viewport || !items.length) return;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var settleTimer = null;

      function inset() {
        var cs = window.getComputedStyle(viewport);
        var v = parseFloat(cs.scrollPaddingLeft || cs.scrollPaddingInlineStart || '0');
        return isNaN(v) ? 0 : v;
      }

      function targetFor(i) {
        return Math.max(0, Math.round(items[i].offsetLeft - inset()));
      }

      function maxScroll() {
        return viewport.scrollWidth - viewport.clientWidth;
      }

      function nearest() {
        var x = viewport.scrollLeft + inset();
        var best = 0, bestD = Infinity;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(items[i].offsetLeft - x);
          if (d < bestD) { bestD = d; best = i; }
        }
        return best;
      }

      function paint() {
        var meter = root.querySelector('[data-feature-meter]');
        if(meter){var extent=Math.max(1,maxScroll());var ratio=Math.min(1,Math.max(0,viewport.scrollLeft/extent));var portion=Math.max(.08,Math.min(1,viewport.clientWidth/Math.max(1,viewport.scrollWidth)));meter.style.width=(portion*100)+'%';meter.style.transform='translateX('+(ratio*(1/portion-1)*100)+'%)';}

        for (var i = 0; i < dots.length; i++) {
          var on = i === index;
          dots[i].setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) dots[i].removeAttribute('tabindex'); else dots[i].setAttribute('tabindex', '-1');
        }
        // At the last snap point the rail may still have a little scroll left
        // (the trailing inset); treat "within 2px of the end" as the end.
        var atEnd = viewport.scrollLeft >= maxScroll() - 2 || index >= items.length - 1;
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = atEnd;
      }

      function go(i, smooth) {
        index = Math.max(0, Math.min(items.length - 1, i));
        var left = Math.min(targetFor(index), maxScroll());
        if (smooth && !reduced && 'scrollBehavior' in document.documentElement.style) {
          viewport.scrollTo({ left: left, behavior: 'smooth' });
        } else {
          viewport.scrollLeft = left;
        }
        paint();
      }

      if (prev) prev.addEventListener('click', function () { go(index - 1, true); });
      if (next) next.addEventListener('click', function () { go(index + 1, true); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          go(parseInt(dot.getAttribute('data-index'), 10) || 0, true);
        });
      });

      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); }
        else if (e.key === 'Home') { e.preventDefault(); go(0, true); }
        else if (e.key === 'End') { e.preventDefault(); go(items.length - 1, true); }
      });

      viewport.addEventListener('scroll', function () {
        if (settleTimer) window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () {
          index = nearest();
          paint();
        }, 80);
      }, { passive: true });

      var lastW = viewport.clientWidth;
      if (window.ResizeObserver) {
        new window.ResizeObserver(function () {
          if (viewport.clientWidth === lastW) return;
          lastW = viewport.clientWidth;
          go(index, false);
        }).observe(viewport);
      }

      paint();
    }

    function boot() {
      var roots = document.querySelectorAll('[data-rt-carousel]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  /**
   * SITE-WIDE HORIZONTAL RAIL HINT — moved here from sections/romatoki-solution.liquid
   * on 2026-09-11 when that section was retired. Unchanged in logic; the
   * keyframe it triggers is re-cut to Apple's motion in the stylesheet above.
   *
   * Plays one short leftward travel on a horizontal rail the first time that
   * rail is halfway into view. Transform on the inner track, never scrollLeft
   * (the rails snap; a scripted scroll is undone before it paints). Gives up
   * on desktop, reduced-motion, no overflow, already-scrolled, any touch or
   * scroll before it fires, or no IntersectionObserver.
   */
  (function () {
    var TOUCH = '(max-width: 749px)';

    function mq(query) {
      return window.matchMedia ? window.matchMedia(query).matches : false;
    }

    function eligible(rail) {
      if (rail.getAttribute('data-rt-hint-done') === 'on') return false;
      if (!mq(TOUCH)) return false;
      if (mq('(prefers-reduced-motion: reduce)')) return false;
      if (rail.scrollWidth <= rail.clientWidth + 1) return false;
      if (rail.scrollLeft > 1) return false;
      return true;
    }

    function arm(rail) {
      if (rail.getAttribute('data-rt-hint-armed') === 'on') return;
      rail.setAttribute('data-rt-hint-armed', 'on');

      var track = rail.querySelector('[data-rt-hint-track]');
      if (!track || !window.IntersectionObserver) return;

      var observer = null;
      var timer = null;

      function detach() {
        rail.removeEventListener('touchstart', cancel);
        rail.removeEventListener('scroll', cancel);
        if (observer) observer.disconnect();
      }

      function cancel() {
        if (timer) { window.clearTimeout(timer); timer = null; }
        rail.setAttribute('data-rt-hint-done', 'on');
        detach();
      }

      function play() {
        timer = null;
        rail.setAttribute('data-rt-hint-done', 'on');
        detach();
        if (rail.scrollLeft > 1) return;
        if (!mq(TOUCH) || mq('(prefers-reduced-motion: reduce)')) return;
        if (rail.scrollWidth <= rail.clientWidth + 1) return;
        track.removeAttribute('data-rt-hint-run');
        void track.offsetWidth;
        track.setAttribute('data-rt-hint-run', '');
        window.setTimeout(function () { track.removeAttribute('data-rt-hint-run'); }, 600);
      }

      observer = new window.IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          if (timer || rail.getAttribute('data-rt-hint-done') === 'on') return;
          if (!eligible(rail)) { cancel(); return; }
          timer = window.setTimeout(play, 450);
          return;
        }
      }, { threshold: 0.5 });

      rail.addEventListener('touchstart', cancel, { passive: true });
      rail.addEventListener('scroll', cancel, { passive: true });
      observer.observe(rail);
    }

    function boot() {
      var rails = document.querySelectorAll('[data-rt-hint]');
      for (var i = 0; i < rails.length; i++) arm(rails[i]);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romatoki-gallery"] && !Shopify.designMode) return;
  try {
    
  /**
   * ROMATOKI lookbook gallery.
   *
   * Three separate jobs, none of which touch the rail's scroll position except
   * through native APIs:
   *   1. progress meter + arrow enabled/disabled state, driven by scroll
   *   2. drag-to-scroll, mouse only
   *   3. the lightbox
   *
   * NO LIQUID IN THIS BLOCK — a tag here ships verbatim and breaks the whole
   * concatenated section bundle for every section on the page.
   */
  (function () {
    var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var FINE_POINTER = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function init(section) {
      if (section.getAttribute('data-rt-gallery-ready') === 'on') return;
      section.setAttribute('data-rt-gallery-ready', 'on');

      var rail = section.querySelector('[data-rt-rail]');
      var track = section.querySelector('[data-rt-track]');
      if (!rail || !track) return;

      var items = track.querySelectorAll('.rt-gallery__item');
      var meter = section.querySelector('[data-rt-meter]');
      var prevBtn = section.querySelector('[data-rt-prev]');
      var nextBtn = section.querySelector('[data-rt-next]');

      // Stagger index for the entrance transition, capped so a long set does
      // not end with photos arriving a second and a half late.
      for (var i = 0; i < items.length; i++) {
        items[i].style.setProperty('--rt-i', String(Math.min(i, 8)));
      }

      /* ---- Entrance ------------------------------------------------------
         One shot, then the observer is dropped. Re-running it on every
         re-entry would animate the rail behind the reader's back every time
         they scrolled past it. */
      if (REDUCED || !('IntersectionObserver' in window)) {
        section.setAttribute('data-enter', 'in');
      } else {
        section.setAttribute('data-enter', 'pending');
        var enterObserver = new IntersectionObserver(
          function (entries, obs) {
            if (!entries[0].isIntersecting) return;
            section.setAttribute('data-enter', 'in');
            obs.disconnect();
          },
          { threshold: 0.12 }
        );
        enterObserver.observe(rail);
      }

      /* ---- Progress + arrow state ---------------------------------------- */
      function maxScroll() {
        return Math.max(1, rail.scrollWidth - rail.clientWidth);
      }

      function syncProgress() {
        var max = maxScroll();
        var ratio = Math.min(1, Math.max(0, rail.scrollLeft / max));
        if (meter) {
          // The fill doubles as a proportional thumb: its width is the share
          // of the rail that fits on screen, and it travels the rest.
          var visible = Math.min(1, rail.clientWidth / Math.max(1, rail.scrollWidth));
          var thumb = Math.max(0.08, visible);
          meter.style.width = thumb * 100 + '%';
          meter.style.transform = 'translateX(' + (ratio * (1 / thumb - 1) * 100) + '%)';
        }
        if (prevBtn) prevBtn.disabled = rail.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = rail.scrollLeft >= max - 2;
      }

      rail.addEventListener('scroll', syncProgress, { passive: true });
      window.addEventListener('resize', syncProgress);
      syncProgress();

      // Images arriving changes scrollWidth, so the meter has to be told.
      var imgs = track.querySelectorAll('img');
      for (var m = 0; m < imgs.length; m++) {
        if (!imgs[m].complete) imgs[m].addEventListener('load', syncProgress, { once: true });
      }

      /* ---- Arrows -------------------------------------------------------
         Native smooth scrolling, because it is the browser's own animation:
         it matches the platform's scrolling feel, it is interruptible by the
         reader, and it already honours the OS reduced-motion setting.

         The timeout is not superstition. Some environments no-op
         `behavior:'smooth'` entirely — measured here, where an instant scroll
         moved the rail and a smooth one left it at 0 — and a button that
         silently does nothing is the worst outcome. So: ask nicely, then
         check, and jump if nothing happened. On a browser where smooth works,
         the rail has always moved well past 2px within 120ms and the fallback
         never fires.

         A step is a bit under a viewport so the photo you were looking at
         stays partly in frame and the move reads as continuous rather than as
         a page flip. */
      function step(dir) {
        var max = maxScroll();
        var target = Math.max(0, Math.min(max, rail.scrollLeft + dir * Math.max(240, rail.clientWidth * 0.8)));
        var before = rail.scrollLeft;
        if (REDUCED) {
          rail.scrollLeft = target;
          return;
        }
        rail.scrollTo({ left: target, behavior: 'smooth' });
        window.setTimeout(function () {
          if (Math.abs(rail.scrollLeft - before) < 2) rail.scrollLeft = target;
        }, 120);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

      /* ---- Drag to scroll (mouse only) ------------------------------------
         Guarded on a fine pointer: on touch this would fight the browser's own
         panning, which is both smoother and already free. */
      if (FINE_POINTER) {
        rail.setAttribute('data-draggable', 'on');
        var down = false;
        var moved = 0;
        var startX = 0;
        var startScroll = 0;

        rail.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = true;
          moved = 0;
          startX = e.clientX;
          startScroll = rail.scrollLeft;
        });

        rail.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 3) {
            moved = Math.max(moved, Math.abs(dx));
            rail.setAttribute('data-dragging', 'on');
            // Capture only once a real drag is underway, so a plain click is
            // never swallowed.
            if (rail.setPointerCapture && e.pointerId != null) {
              try { rail.setPointerCapture(e.pointerId); } catch (err) {}
            }
          }
          if (moved) rail.scrollLeft = startScroll - dx;
        });

        function endDrag() {
          if (!down) return;
          down = false;
          rail.removeAttribute('data-dragging');
        }

        rail.addEventListener('pointerup', endDrag);
        rail.addEventListener('pointercancel', endDrag);
        rail.addEventListener('pointerleave', endDrag);

        // Suppress the click that a drag would otherwise fire, so releasing
        // the mouse over a photo after dragging does not open the lightbox.
        rail.addEventListener(
          'click',
          function (e) {
            if (moved > 4) {
              e.preventDefault();
              e.stopPropagation();
              moved = 0;
            }
          },
          true
        );
      }

      /* ---- Lightbox ------------------------------------------------------- */
      var lb = section.querySelector('[data-rt-lb]');
      if (!lb || typeof lb.showModal !== 'function') return;

      var slides = lb.querySelectorAll('[data-rt-lb-slide]');
      var lbPrev = lb.querySelector('[data-rt-lb-prev]');
      var lbNext = lb.querySelector('[data-rt-lb-next]');
      var lbClose = lb.querySelector('[data-rt-lb-close]');
      var lbIndexEl = lb.querySelector('[data-rt-lb-index]');
      var lbCaptionEl = lb.querySelector('[data-rt-lb-caption]');
      var openers = section.querySelectorAll('[data-rt-open]');
      var current = 0;
      var lastOpener = null;
      var closeHandled = true;
      var lockedEl = null;
      var lockedPrev = '';

      /**
       * Horizon scrolls `.page-wrapper`, NOT the document — so locking
       * `documentElement.style.overflow` while the lightbox is open does
       * nothing at all, and the page happily scrolls away behind the modal.
       * Lock whatever is actually the scroll container, and put back whatever
       * value was there before rather than assuming it was empty.
       */
      function pageScroller() {
        return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
      }

      function lockScroll() {
        if (lockedEl) return;
        lockedEl = pageScroller();
        lockedPrev = lockedEl.style.overflow;
        lockedEl.style.overflow = 'hidden';
      }

      function unlockScroll() {
        if (!lockedEl) return;
        lockedEl.style.overflow = lockedPrev;
        lockedEl = null;
      }

      /**
       * Everything that ends the lightbox funnels through here, and it is
       * idempotent so it cannot double-fire.
       *
       * It is deliberately NOT hung off the dialog's `close` event alone:
       * that event was measured never firing in testing, and if the only
       * unlock lives there then a shopper who closes the viewer is left on a
       * page that will not scroll — the worst possible failure for this
       * feature. `close` and `cancel` are still listened to, but as
       * belt-and-braces on top of the explicit calls.
       */
      function afterClose() {
        if (closeHandled) return;
        closeHandled = true;
        unlockScroll();
        // Send focus back where it came from, or the reader lands at the top
        // of the document with no idea where they were.
        if (lastOpener && typeof lastOpener.focus === 'function') {
          lastOpener.focus({ preventScroll: true });
        }
      }

      function closeLb() {
        if (lb.open) {
          try { lb.close(); } catch (err) {}
        }
        afterClose();
      }

      function captionFor(i) {
        var item = items[i];
        if (!item) return '';
        var cap = item.querySelector('.rt-gallery__caption');
        return cap ? cap.textContent.trim() : '';
      }

      function show(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        for (var s = 0; s < slides.length; s++) {
          var on = s === current;
          slides[s].classList.toggle('is-active', on);
          // Fetch on demand, and pre-fetch the neighbours so a click on the
          // arrow never shows an empty frame.
          var near = Math.abs(s - current) <= 1 ||
            (current === 0 && s === slides.length - 1) ||
            (current === slides.length - 1 && s === 0);
          if (near && !slides[s].src && slides[s].dataset.src) {
            slides[s].src = slides[s].dataset.src;
          }
        }
        if (lbIndexEl) lbIndexEl.textContent = String(current + 1);
        if (lbCaptionEl) lbCaptionEl.textContent = captionFor(current);
        if (lbPrev) lbPrev.disabled = false;
        if (lbNext) lbNext.disabled = false;
      }

      function openAt(i, opener) {
        // Nothing to show means nothing to open — this only happens in the
        // theme editor before any photos have been chosen.
        if (!slides.length) return;
        lastOpener = opener || null;
        closeHandled = false;
        show(i);
        lb.showModal();
        lockScroll();
      }

      for (var o = 0; o < openers.length; o++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            openAt(parseInt(btn.getAttribute('data-rt-open'), 10) || 0, btn);
          });
        })(openers[o]);
      }

      if (lbPrev) lbPrev.addEventListener('click', function () { show(current - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { show(current + 1); });
      if (lbClose) lbClose.addEventListener('click', closeLb);

      // Clicking the empty space around the photo closes, the way every image
      // viewer behaves. The stage itself is excluded so a click on the photo
      // does not.
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.classList.contains('rt-gallery__lb-inner')) closeLb();
      });

      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
        else if (e.key === 'Escape') {
          // The dialog closes itself natively; this just makes sure the
          // unlock happens even where `close`/`cancel` do not arrive.
          window.setTimeout(afterClose, 0);
        }
      });

      lb.addEventListener('cancel', function () { window.setTimeout(afterClose, 0); });
      lb.addEventListener('close', afterClose);
    }

    function boot() {
      var sections = document.querySelectorAll('[data-rt-gallery]');
      for (var i = 0; i < sections.length; i++) init(sections[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romatoki-pack-scroll"]) return;
  try {
    
  (function () {
    if (window.__rtPackScroll2) return;
    window.__rtPackScroll2 = true;

    function headerOffset() {
      var h = document.querySelector('[id*="romatoki_header"]');
      var bottom = h ? h.getBoundingClientRect().bottom : 0;
      if (!(bottom > 0) || bottom > 140) bottom = 60;
      return bottom + 12;
    }

    function scroller(el) {
      var p = el.parentElement;
      while (p && p !== document.body && p !== document.documentElement) {
        var oy = window.getComputedStyle(p).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight + 1) return p;
        p = p.parentElement;
      }
      return null;
    }

    function bringPickerIntoView(picker) {
      var offset = headerOffset();
      var top = picker.getBoundingClientRect().top;
      var comfortable = top >= offset && top <= window.innerHeight * 0.55;
      if (comfortable) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var behavior = reduce ? 'auto' : 'smooth';
      var distance = top - offset;
      var box = scroller(picker);
      if (box) {
        box.scrollTo({ top: box.scrollTop + distance, behavior: behavior });
      } else {
        window.scrollTo({ top: window.pageYOffset + distance, behavior: behavior });
      }
    }

    document.addEventListener('click', function (e) {
      if (!e.isTrusted) return;
      var card = e.target && e.target.closest ? e.target.closest('.rt-packs .rt-pack') : null;
      if (!card) return;
      var root = card.closest('.rt-packs');
      var picker = root ? root.querySelector('.rt-picker') : null;
      if (!picker) return;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { bringPickerIntoView(picker); });
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romatoki-packs"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-copy-code]');
  if (!button) return;
  const status = button.closest('.rt-pivot__promo').querySelector('[data-copy-status]');
  try { await navigator.clipboard.writeText(button.dataset.copyCode); status.textContent = button.dataset.copied; }
  catch { status.textContent = button.dataset.copyFailed; }
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romatoki-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-reviews]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  function init(root) {
    if (root.dataset.reviewsReady === 'true') return;
    root.dataset.reviewsReady = 'true';

    var tabs = root.querySelectorAll('[data-reviews-tab]');
    var panels = root.querySelectorAll('[data-reviews-panel]');
    if (tabs.length < 2 || tabs.length !== panels.length) return;

    var index = 0;

    /* Tabs and panels are paired by position, so nothing here depends on the
       generated ids and the markup can be renumbered freely.

       `is-before` is the whole of the slide direction. Panels above the
       current index keep their default resting offset (to the right) and
       panels below it get the mirrored one, so the CSS works out which way
       everything travels from the ordering alone. There is no direction flag
       to get out of step, and overlapping clicks cannot confuse it. */
    function paint() {
      for (var i = 0; i < tabs.length; i++) {
        var on = i === index;
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].tabIndex = on ? 0 : -1;
        panels[i].classList.toggle('is-current', on);
        panels[i].classList.toggle('is-before', i < index);
      }
    }

    function select(next, focus) {
      if (next < 0) next = tabs.length - 1;
      if (next > tabs.length - 1) next = 0;
      index = next;
      paint();
      if (focus) tabs[index].focus();
    }

    paint();

    for (var k = 0; k < tabs.length; k++) {
      (function (i) {
        tabs[i].addEventListener('click', function () { select(i, false); });
      })(k);
    }

    /* Arrow keys move between tabs, Home and End jump to the ends. This is the
       standard tablist keyboard contract and screen-reader users expect it. */
    root.querySelector('[data-reviews-tabs]').addEventListener('keydown', function (event) {
      var key = event.key;
      if (key === 'ArrowRight' || key === 'ArrowDown') { event.preventDefault(); select(index + 1, true); }
      else if (key === 'ArrowLeft' || key === 'ArrowUp') { event.preventDefault(); select(index - 1, true); }
      else if (key === 'Home') { event.preventDefault(); select(0, true); }
      else if (key === 'End') { event.preventDefault(); select(tabs.length - 1, true); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romatoki-solution"] && !Shopify.designMode) return;
  try {
    
  /**
   * SITE-WIDE HORIZONTAL RAIL HINT
   * ------------------------------
   * Plays one short leftward spring on a horizontal rail the first time that
   * rail is halfway into view, so a visitor who would never have thought to
   * swipe sees that the row moves.
   *
   * WHY THIS LIVES HERE. Shopify concatenates every rendered section's
   * javascript block into one page bundle, so a controller defined in any
   * section can drive the whole page. It is
   * defined once here and picks up every element carrying data-rt-hint
   * anywhere in the document — today the feature rail in this section and the
   * lookbook rail in romatoki-gallery. If this section is ever removed from a
   * template that still has other rails, this block has to move with them.
   *
   * WHAT IT DELIBERATELY DOES NOT DO. It never writes scrollLeft. The rails
   * snap, and a scripted scroll on a snapping container is undone before it
   * paints. The animation is a transform on the inner track, which is paint
   * only: scroll position, snap points and scrollWidth are all untouched, so a
   * visitor who swipes mid-hint gets exactly the swipe they asked for.
   *
   * IT GIVES UP EASILY, ON PURPOSE:
   *   - desktop: no hint (there is no swipe gesture to teach)
   *   - prefers-reduced-motion: no hint
   *   - rail not actually overflowing: no hint
   *   - rail already scrolled: no hint, they found it themselves
   *   - any touch or scroll before it fires: cancelled for good
   *   - no IntersectionObserver: no hint, rather than firing off-screen
   *
   * The 450ms settle delay matters. Firing the instant the rail crosses 50%
   * means firing while the page is still travelling under a flick, which is a
   * hint nobody sees.
   *
   * No Liquid in this block — see the note on the edge-bump controller below.
   */
  (function () {
    var TOUCH = '(max-width: 749px)';

    function mq(query) {
      return window.matchMedia ? window.matchMedia(query).matches : false;
    }

    function eligible(rail) {
      if (rail.getAttribute('data-rt-hint-done') === 'on') return false;
      if (!mq(TOUCH)) return false;
      if (mq('(prefers-reduced-motion: reduce)')) return false;
      if (rail.scrollWidth <= rail.clientWidth + 1) return false;
      if (rail.scrollLeft > 1) return false;
      return true;
    }

    function arm(rail) {
      if (rail.getAttribute('data-rt-hint-armed') === 'on') return;
      rail.setAttribute('data-rt-hint-armed', 'on');

      var track = rail.querySelector('[data-rt-hint-track]');
      if (!track || !window.IntersectionObserver) return;

      var observer = null;
      var timer = null;

      function detach() {
        rail.removeEventListener('touchstart', cancel);
        rail.removeEventListener('scroll', cancel);
        if (observer) observer.disconnect();
      }

      function cancel() {
        if (timer) {
          window.clearTimeout(timer);
          timer = null;
        }
        rail.setAttribute('data-rt-hint-done', 'on');
        detach();
      }

      function play() {
        timer = null;
        rail.setAttribute('data-rt-hint-done', 'on');
        detach();
        // Re-checked here and not only at arm time: the viewport can have been
        // rotated or resized between the two.
        if (rail.scrollLeft > 1) return;
        if (!mq(TOUCH) || mq('(prefers-reduced-motion: reduce)')) return;
        if (rail.scrollWidth <= rail.clientWidth + 1) return;

        // Restarting a CSS animation needs the attribute gone and a layout
        // read in between, or both writes coalesce and nothing runs.
        track.removeAttribute('data-rt-hint-run');
        void track.offsetWidth;
        track.setAttribute('data-rt-hint-run', '');
        window.setTimeout(function () {
          track.removeAttribute('data-rt-hint-run');
        }, 700);
      }

      observer = new window.IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            if (timer || rail.getAttribute('data-rt-hint-done') === 'on') return;
            if (!eligible(rail)) {
              cancel();
              return;
            }
            timer = window.setTimeout(play, 450);
            return;
          }
        },
        { threshold: 0.5 }
      );

      rail.addEventListener('touchstart', cancel, { passive: true });
      rail.addEventListener('scroll', cancel, { passive: true });
      observer.observe(rail);
    }

    function boot() {
      var rails = document.querySelectorAll('[data-rt-hint]');
      for (var i = 0; i < rails.length; i++) arm(rails[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  /**
   * Edge feedback for the feature-card rail.
   *
   * `overscroll-behavior: contain` stops the page from taking the gesture over
   * when the rail runs out, which is what made a scroll feel like it changed
   * its mind halfway. The cost is that the rail then simply goes dead at the
   * end with nothing to explain why, so this puts a short spring there.
   *
   * Drives a CSS animation via a data attribute rather than writing transforms
   * from script: the curve, the overshoot and the reduced-motion opt-out all
   * live in the stylesheet where they can be tuned without touching logic.
   *
   * No Liquid anywhere in this block. Liquid is not rendered inside a
   * section's javascript block, so a tag here would ship verbatim and take the
   * whole concatenated section bundle down with a syntax error.
   */
  (function () {
    function init(scroller) {
      var track = scroller.querySelector('.rt-showcase__cards-scroll');
      if (!track || scroller.dataset.rtEdge === 'on') return;
      scroller.dataset.rtEdge = 'on';

      var clearTimer = null;

      function bump(name) {
        // Restarting an animation needs the attribute gone and a layout read
        // in between, or the browser coalesces both writes and nothing runs.
        track.removeAttribute('data-bump');
        void track.offsetWidth;
        track.setAttribute('data-bump', name);
        if (clearTimer) window.clearTimeout(clearTimer);
        clearTimer = window.setTimeout(function () {
          track.removeAttribute('data-bump');
          clearTimer = null;
        }, 460);
      }

      scroller.addEventListener(
        'wheel',
        function (event) {
          if (track.hasAttribute('data-bump')) return;

          var horizontal = scroller.scrollWidth > scroller.clientWidth + 1;
          var delta = horizontal
            ? Math.abs(event.deltaX) > Math.abs(event.deltaY)
              ? event.deltaX
              : event.deltaY
            : event.deltaY;
          if (!delta) return;

          var pos = horizontal ? scroller.scrollLeft : scroller.scrollTop;
          var max = horizontal
            ? scroller.scrollWidth - scroller.clientWidth
            : scroller.scrollHeight - scroller.clientHeight;
          if (max < 1) return;

          // 1px of slack — sub-pixel scroll offsets on zoomed or high-DPI
          // displays mean an exact comparison never matches the end.
          var axis = horizontal ? 'x' : 'y';
          if (pos <= 1 && delta < 0) bump(axis + '-start');
          else if (pos >= max - 1 && delta > 0) bump(axis + '-end');
        },
        { passive: true }
      );
    }

    function boot() {
      var rails = document.querySelectorAll('.rt-showcase__cards');
      for (var i = 0; i < rails.length; i++) init(rails[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
